module.exports = __webpack_public_path__ + "img/anchor.8a4b229e.svg";